import React, { createContext, useContext, useReducer, useEffect } from 'react';

const ProjectContext = createContext(null);

const ProjectDispatchContext = createContext(null);

const projectReducer = (state, action) => {
    const draft = { ...state };

    switch (action.type) {
        case 'SetProjectId':
            draft.projectId = action.projectId;
            return draft;
        case 'SetProjectData':
            draft.projectData = action.projectData;
            if (action.projectData?.ID) {
                draft.projectId = action.projectData.ID;
            }
            return draft;
        case 'UpdateProjectData':
            draft.projectData = action.projectData;
            if (action.projectData?.ID) {
                draft.projectId = action.projectData.ID;
            }
            return draft;
        case 'SetSelectedEvent':
            draft.selectedEvent = {
                ID: action.eventID,
                TypeName: action.eventType,
            };
            return draft;
        case 'ClearSelectedEvent':
            draft.selectedEvent = null;
            return draft;
        case 'SetLayout':
            draft.layout = action.layout;
            return draft;
        case 'SetAccountingDetails':
            draft.accountingDetails = action.accountingDetails;
            return draft;
        case 'SetTransactionsGrouped':
            draft.transactionsGrouped = action.transactionsGrouped;
            return draft;
        case 'Reset':
            draft.selectedEvent = null;
            draft.layout = 'overview';
            return draft;
        default:
            return state;
    }
};

export function ProjectProvider({ children, initialProjectData = null, initialLayout = 'overview' }) {
    const PROJECT_INITIAL_STATE = {
        projectId: initialProjectData?.ID || null,
        projectData: initialProjectData,
        selectedEvent: null,
        layout: initialLayout,
        accountingDetails: null,
        transactionsGrouped: null,
    };

    const [data, dispatch] = useReducer(projectReducer, PROJECT_INITIAL_STATE);

    return (
        <ProjectContext.Provider value={data}>
            <ProjectDispatchContext.Provider value={dispatch}>{children}</ProjectDispatchContext.Provider>
        </ProjectContext.Provider>
    );
}

export function useProjectContext() {
    return useContext(ProjectContext);
}

export function useProjectContextDispatch() {
    return useContext(ProjectDispatchContext);
}

// Helper function to reload accounting data
export async function reloadProjectAccountingData(projectId, dispatch) {
    try {
        const Axios = (await import('axios')).default;

        // Fetch accounting details
        const accountingDetails = await Axios.get(`/projects/getdetailsforaccounting/${projectId}`);
        dispatch({ type: 'SetAccountingDetails', accountingDetails });

        // Fetch transactions grouped by model and day
        const transactionsGrouped = await Axios.get(`/projects/TransactionsGroupedByModelAndDay/${projectId}`);
        dispatch({ type: 'SetTransactionsGrouped', transactionsGrouped });
    } catch (error) {
        console.error('Error reloading accounting data:', error);
    }
}
